var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSiTrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8442 3.3319L21.2764 4.71846L16.5981 9.34032L13.4472 6.2899C13.0653 5.92015 12.4924 5.92015 12.1105 6.2899L6.28643 11.9285C5.90452 12.2983 5.90452 12.8529 6.28643 13.2227C6.66834 13.5924 7.24123 13.5924 7.62314 13.2227L12.779 8.23106L15.9296 11.2815C16.3115 11.6513 16.8844 11.6513 17.2663 11.2815L22.7085 6.0126L24.1407 7.39916C24.4271 7.67647 25 7.49157 25 7.02939V2.96219C25 2.68487 24.809 2.5 24.5226 2.5H20.3216C19.7487 2.5 19.5578 3.05459 19.8442 3.3319Z",
    fill: "#DFE0E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0478 10.5C23.0002 10.5 23.7621 11.2347 23.7621 12.1531V26.8469C23.7621 27.7653 23.0002 28.5 22.0478 28.5C21.0954 28.5 20.3336 27.7653 20.3336 26.8469V12.1531C20.2383 11.2347 21.0954 10.5 22.0478 10.5ZM7.95261 21.7959C8.90499 21.7959 9.66683 22.5306 9.66683 23.449V26.8469C9.66683 27.7653 8.90499 28.5 7.95261 28.5C7.00023 28.5 6.23828 27.7653 6.23828 26.8469V23.449C6.23828 22.5306 7.00023 21.7959 7.95261 21.7959ZM15.0001 16.102C15.9525 16.102 16.7145 16.8368 16.7145 17.7551V26.7551C16.7145 27.6735 15.9525 28.4082 15.0001 28.4082C14.0478 28.4082 13.2859 27.6735 13.2859 26.7551V17.8469C13.1907 16.9286 14.0478 16.102 15.0001 16.102Z",
    fill: "#DFE0E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiTrade);
export default __webpack_public_path__ + "static/media/si_trade.343b5550b954cd0b08ae93c33673f0e3.svg";
export { ForwardRef as ReactComponent };